import type {
    CollectionFragment,
    MetadataFragment,
} from '~/lib/graphql/graphql.ts'

export function toLongDateString(
    item: MetadataFragment | CollectionFragment | null,
) {
    const date = item?.attributes?.published
    if (!date) return ''
    const d = new Date(date)
    const month = d.toLocaleDateString('default', { month: 'long' })
    return month + ' ' + d.getDate() + ', ' + d.getFullYear()
}

export function toShortDateString(
    item: MetadataFragment | CollectionFragment | null,
) {
    const date = item?.attributes?.published
    if (!date) return ''
    const d = new Date(date)
    return d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate()
}
